module.exports = __webpack_public_path__ + "static/media/bet.392b6cdc.png";